import {
  SET_USER,
} from './actions';

const initialState = {
  loggedUser: null,
};

export const reducer = (state = initialState, action) => {
  if (action.type === SET_USER) {
    return {
      ...state,
      loggedUser: action.payload,
    };
  }
  return state;
};
